import { Block, CalendarMonth, CheckCircle } from '@mui/icons-material';
import { Box, Button, Paper, Typography } from '@mui/material';

interface QuickActionsProps {
  onBlock: () => void;
  onSetAvailable: () => void;
}

const QuickActions: React.FC<QuickActionsProps> = ({ onBlock, onSetAvailable }) => {
  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
        Quick Actions
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Button
          variant="contained"
          color="error"
          startIcon={<Block />}
          onClick={onBlock}
          fullWidth
          sx={{ borderRadius: 25, textTransform: 'none', fontWeight: 600 }}
        >
          Block Dates
        </Button>
        <Button
          variant="outlined"
          startIcon={<CheckCircle />}
          onClick={onSetAvailable}
          fullWidth
          sx={{ borderRadius: 25, textTransform: 'none', fontWeight: 600 }}
        >
          Set Available Dates
        </Button>
        <Button
          variant="outlined"
          startIcon={<CalendarMonth />}
          onClick={() => console.log('Sync with Google Calendar — not implemented yet')}
          fullWidth
          sx={{ borderRadius: 25, textTransform: 'none', fontWeight: 600 }}
        >
          Sync with Google Calendar
        </Button>
      </Box>
    </Paper>
  );
};

export default QuickActions;
